import { filter } from 'rxjs';
import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RawMetalService } from '../../../../Services/Raw_Metal/raw-metal.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import FileSaver from 'file-saver';
import Swal from 'sweetalert2';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-raw-stone-list',
  imports: [NgFor, FormsModule, NgIf, RouterLink],
  templateUrl: './raw-stone-list.component.html',
  styleUrl: './raw-stone-list.component.css',
})
export class RawStoneListComponent implements OnInit {
  paginatedStockList: any[] = [];
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 0;
  rawStonelist: any;
  rawmetaldata: any;
  rawmetalId: any;
  rawMetalProductId: any;
  rawMetalEntryForm: any;
  item: any;
  //image map for stone pdf 
  stoneImageMap = new Map<number, string>();

  searchValues: { [key: string]: string } = {};
  sortKey: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  showDropdown: boolean = false;
  defaultFields: any;
  visibleRowCount: any;
  startDate: string = '';
endDate: string = '';
  filteredStockList: any[] = [];

  constructor(
    private rawmetalservice: RawMetalService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    const savedMode = localStorage.getItem('stoneViewMode');
    this.selectedViewMode = 'all';
    console.log('asdfghj', savedMode);

    this.updateSelectedFields();

    this.getRawStoneList();
  }

  getRawStoneList() {
    this.rawmetalservice.getRawMetalEntries().subscribe((response: any) => {
      if (response?.data?.length) {
        this.rawStonelist = response.data
          .filter((item: any) => item.st_product_code_type === 'raw_stone')
          .sort((a: any, b: any) => b.id - a.id);

        this.totalPages = Math.ceil(
          this.rawStonelist.length / this.itemsPerPage
        );

        this.updatePaginatedList();

        this.filterByViewMode();
      } else {
        this.rawStonelist = [];
        this.paginatedStockList = [];
        this.totalPages = 0;
      }
    });
  }

  deleteMetal(id: any) {
    this.rawmetalservice.deleteRawMetalEntry(id).subscribe(
      (response: any) => {
        this.notificationService.showSuccess(
          'Raw Stone deleted successfully!',
          'Success'
        );
        this.getRawStoneList();
      },
      (error: any) => {
        this.notificationService.showError(
          'Failed to delete raw Stone. Please try again.',
          'Error'
        );
      }
    );
  }

  selectedViewMode: string = 'byLine';

  selectedFields: any[] = [];


  filterByViewMode() {
    if (!this.rawStonelist || !Array.isArray(this.rawStonelist)) {
      return;
    }

    if (this.selectedViewMode === 'all') {
      this.filteredStockList = [...this.rawStonelist];
    } else if (this.selectedViewMode === 'byLine') {
      this.filteredStockList = this.rawStonelist.filter(
        (item) => item.st_product_type === 'By Line'
      );
    } else if (this.selectedViewMode === 'byStone') {
      this.filteredStockList = this.rawStonelist.filter(
        (item) => item.st_product_type === 'By Stone'
      );
    } else if (this.selectedViewMode === 'byGram') {
      this.filteredStockList = this.rawStonelist.filter(
        (item) => item.st_product_type === 'By Gram'
      );
    }


    this.updatePaginatedList();
  }

  updateSelectedFields(): void {

    localStorage.setItem('stoneViewMode', this.selectedViewMode);

    if (this.selectedViewMode === 'all') {
      this.selectedFields = [
        { key: 'st_image1', label: 'Product Image', isImage: true, selected: true },
        { key: 'st_item_code', label: 'Code', selected: true },
        { key: 'st_item_name', label: 'Name', selected: true },
        {
          key: 'st_item_category',
          label: 'Category',
          subKey: 'name',
          selected: true,
        },
        { key: 'st_product_type', label: 'Stone Type', selected: true },
        { key: 'st_item_size', label: 'Size', selected: true },
        { key: 'st_color', label: 'Color', selected: true },
        { key: 'st_unit_price', label: 'Total Price', selected: true },
        { key: 'st_total_wt', label: 'Total Stone WT', selected: true },
        {
          key: 'st_subunit',
          label: 'Total stone in Each line',
          selected: true,
        },
        { key: 'st_unit_quantity', label: 'Total Line', selected: true },
        { key: 'st_quantity', label: 'Quantity', selected: true },
        { key: 'st_unit_price', label: 'Per Line/Gram Price', selected: true },
        { key: 'st_sub_unit_price', label: 'Per Stone Price', selected: true },
        { key: 'created_at', label: 'Date', isDate: true, selected: true },
      ];
    } else if (this.selectedViewMode === 'byLine') {
      this.selectedFields = [
        { key: 'st_image1', label: 'Product Image', isImage: true, selected: true },       
        {
          key: 'st_item_category',
          label: 'Category',
          selected: true,
          subKey: 'name',
        },
        { key: 'st_item_name', label: 'Name', selected: true },
        { key: 'st_item_code', label: 'Code', selected: true },
        { key: 'st_product_type', label: 'Stone Type', selected: true },
        { key: 'st_unit_price', label: 'Per Line Price', selected: true },
        
        {
          key: 'st_avg_unit_price',
          label: 'Avg Per line Price',
          selected: true,
        },
        { key: 'st_subunit', label: 'Per Stone in Each Line', selected: true },
        {
          key: 'st_avg_subunit',
          label: 'Avg Per Stone in Each Line',
          selected: true,
        },
        { key: 'st_unit_quantity', label: 'Total Line ', selected: true },
        {
          key: 'st_avg_unit_quantity',
          label: 'Avg Total Line',
          selected: true,
        },
        { key: 'st_quantity', label: 'Quantity', selected: true },
        { key: 'st_sub_unit_price', label: 'Per Stone Price', selected: true },
        {
          key: 'st_avg_sub_unit_price',
          label: 'Avg Per Stone Price',
          selected: true,
        },
        { key: 'created_at', label: 'Date', isDate: true, selected: true },
      ];
    } else if (this.selectedViewMode === 'byStone') {
      this.selectedFields = [
        {
          key: 'st_item_category',
          label: 'Category',
          selected: true,
          subKey: 'name',
        },
        { key: 'st_item_name', label: 'Name', selected: true },
        { key: 'st_item_code', label: 'Code', selected: true },
        { key: 'st_product_type', label: 'Stone Type', selected: true },
        { key: 'st_quantity', label: 'Quantity', selected: true },
        { key: 'st_image', label: 'Product Image', isImage: true, selected: true },
        { key: 'st_sub_unit_price', label: 'Per Stone Price', selected: true },
        {
          key: 'st_avg_sub_unit_price',
          label: 'Avg Per Stone Price',
          selected: true,
        },
        { key: 'created_at', label: 'Date', isDate: true, selected: true },
      ];
    } else if (this.selectedViewMode === 'byGram') {
      this.selectedFields = [
        { key: 'st_image1', label: 'Product Image', isImage: true, selected: true },
        {
          key: 'st_item_category',
          label: 'Category',
          selected: true,
          subKey: 'name',
        },
        { key: 'st_item_name', label: 'Name', selected: true },
        { key: 'st_item_code', label: 'Code', selected: true },
        { key: 'st_product_type', label: 'Stone Type', selected: true },
        { key: 'st_subunit', label: 'Each Stone Weight', selected: true },
        {
          key: 'st_avg_subunit',
          label: 'Avg Per Stone Weight',
          selected: true,
        },
        { key: 'st_total_wt', label: 'Total Stone Weight', selected: true },
        { key: 'st_unit_price', label: 'Per Gram Price', selected: true },
        {
          key: 'st_avg_unit_price',
          label: 'Avg Per Gram Price',
          selected: true,
        },
        { key: 'st_quantity', label: 'Quantity', selected: true },
        { key: 'st_sub_unit_price', label: 'Per Stone Price', selected: true },
        {
          key: 'st_avg_sub_unit_price',
          label: 'Avg Per Stone Price',
          selected: true,
        },
        { key: 'created_at', label: 'Date', isDate: true, selected: true },
      ];
    }

    this.filterByViewMode();
  }

  filterTable() {

  if (!this.rawStonelist) return;

  let filtered = this.rawStonelist.filter((item: any) => {

    /* ================= VIEW MODE ================= */

    if (this.selectedViewMode !== 'all') {

      if (this.selectedViewMode === 'byLine' && item.st_product_type !== 'By Line')
        return false;

      if (this.selectedViewMode === 'byStone' && item.st_product_type !== 'By Stone')
        return false;

      if (this.selectedViewMode === 'byGram' && item.st_product_type !== 'By Gram')
        return false;
    }

    /* ================= DATE FILTER ================= */

    if (this.startDate || this.endDate) {

      const createdAt = item['created_at'];
      if (!createdAt) return false;

      const itemDate = new Date(createdAt).setHours(0, 0, 0, 0);

      const start = this.startDate
        ? new Date(this.startDate).setHours(0, 0, 0, 0)
        : null;

      const end = this.endDate
        ? new Date(this.endDate).setHours(0, 0, 0, 0)
        : null;

      if (start && itemDate < start) return false;
      if (end && itemDate > end) return false;
    }

    /* ================= COLUMN FILTER ================= */

    const matchesFieldFilters = this.selectedFields.every(field => {

      const searchTerm = (this.searchValues[field.key] || '')
        .trim()
        .toLowerCase();

      if (!searchTerm) return true;

      const fieldValue = (item[field.key] ?? '')
        .toString()
        .toLowerCase();

      return fieldValue.includes(searchTerm);
    });

    /* ================= GLOBAL SEARCH ================= */

    const matchesGlobalSearch = this.globalSearchText
      ? Object.values(item).some(val =>
          (val ?? '')
            .toString()
            .toLowerCase()
            .includes(this.globalSearchText.trim().toLowerCase())
        )
      : true;

    return matchesFieldFilters && matchesGlobalSearch;
  });

  /* ================= SORT ================= */

  if (this.sortKey) {
    filtered.sort((a: any, b: any) => {

      const valA = a[this.sortKey] ?? '';
      const valB = b[this.sortKey] ?? '';

      return this.sortDirection === 'asc'
        ? valA > valB ? 1 : valA < valB ? -1 : 0
        : valA < valB ? 1 : valA > valB ? -1 : 0;
    });
  }

  /* ================= SAVE FILTERED ================= */

  this.filteredStockList = filtered;

  /* ================= PAGINATION ================= */

  this.totalPages = Math.ceil(filtered.length / this.itemsPerPage);
  this.currentPage = Math.min(this.currentPage, this.totalPages || 1);

  const start = (this.currentPage - 1) * this.itemsPerPage;

  this.paginatedStockList = filtered.slice(
    start,
    start + this.itemsPerPage
  );
}

  globalSearchText: string = '';

  sortBy(key: string) {
    if (this.sortKey === key) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortKey = key;
      this.sortDirection = 'asc';
    }
    this.filterTable();
  }

  updateVisibleRows() {
    this.paginatedStockList = this.rawStonelist.slice(0, this.visibleRowCount);
  }

  getDisplayValue(value: any, subKey?: string): string {
    if (value == null) return '';

    if (typeof value === 'object') {
      return subKey && value[subKey] != null
        ? value[subKey]
        : JSON.stringify(value);
    }

    return String(value);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.filterTable();
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePaginatedList();
    }
  }

  updatePaginatedList() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedStockList = this.filteredStockList.slice(
      startIndex,
      endIndex
    );
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedList();
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedList();
    }
  }

  get pageNumbers(): number[] {
    return Array(this.totalPages)
      .fill(0)
      .map((_, i) => i + 1);
  }

  selectAllFields() {
    this.selectedFields.forEach((field) => (field.selected = true));
  }

  deselectAllFields() {
    this.selectedFields.forEach((field) => (field.selected = false));
  }

  get selectedFieldss() {
    return this.selectedFields.filter((field) => field.selected);
  }

  applyColumnSelection() {
    localStorage.setItem('stoneselected', JSON.stringify(this.selectedFields));
    this.showDropdown = false;
  }
  


 formatPdfValue(value: any, field?: any): any {
  if (
    field?.isImage ||
    field?.key === 'product_image' ||
    field?.key === 'stone_image'
  ) {
    return value; // 🔥 RAW URL/Base64
  }

  if (value === null || value === undefined || value === '') return '-';

  if (field?.isDate) {
    return this.formatDate(value);
  }

  if (!isNaN(value) && typeof value !== 'object') {
    return Number(value).toFixed(2);
  }

  if (typeof value === 'object') {
    if (field?.subKey && value[field.subKey] != null) {
      return value[field.subKey];
    }

    return Object.values(value)
      .filter(v => typeof v !== 'object')
      .join(', ');
  }

  return String(value);
}
proxyImageUrl(url: string): string {

  if (!url) return url;

  if (url.includes('/api/image-proxy/')) return url;

  const match = url.match(/\/storage\/(.+)$/);

  if (!match) return url;

  const backendBase =
    environment.apiBaseUrl.replace(/\/api\/$/, '');

  return `${backendBase}/api/image-proxy/${match[1]}`;
}
async loadImageBase64(url: string): Promise<string | null> {
  try {

    const proxiedUrl = this.proxyImageUrl(url);

    console.log('🟡 Loading image:', proxiedUrl);

    const res = await fetch(proxiedUrl);

    if (!res.ok) {
      console.error('❌ HTTP error:', res.status);
      throw new Error(res.statusText);
    }

    const blob = await res.blob();

    return await new Promise(resolve => {
      const reader = new FileReader();
      reader.onloadend = () =>
        resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });

  } catch (err) {
    console.error('🔥 Image load FAILED:', url, err);
    return null;
  }
}


async prepareStoneImages(): Promise<void> {

  console.log('📦 Preloading Raw Stone images...');

  this.stoneImageMap.clear();

   const dataToProcess = this.getExportSourceData();
    for (const row of dataToProcess as any[]) {

    const imgUrl = row.st_image1; // ✅ STONE KEY

    console.log('➡ Row stone image:', imgUrl);
    console.log('🔍 FULL STONE ROW:', row);


    if (!imgUrl) continue;

    const base64 = await this.loadImageBase64(imgUrl);

    if (base64) {
      this.stoneImageMap.set(row.st_id, base64);
      console.log('🟢 Stone image OK');
    } else {
      console.log('❌ Stone image NULL');
    }
  }

  console.log('📦 Raw Stone preload finished');
}


  ////////////////////////////////////////////////////////////////
// 🧾 MAIN RAW STONE PDF EXPORT
////////////////////////////////////////////////////////////////

async downloadPDF(): Promise<void> {

  // 🔥 PRELOAD STONE IMAGES FIRST
  await this.prepareStoneImages();

  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a3',
  });

  const selectedFields =
    this.selectedFields.filter(f => f.selected);

  if (!selectedFields.length) {
    this.notificationService.showError(
      'Please select at least one column',
      'Error'
    );
    return;
  }

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  /* ================= HEADER ================= */

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);

  doc.text(
    'Raw Stone Report',
    pageWidth / 2,
    16,
    { align: 'center' }
  );

  doc.setFontSize(9);

  doc.text(
    `View Mode: ${this.selectedViewMode.toUpperCase()}`,
    15,
    10
  );

  doc.text(
    `Generated on: ${new Date().toLocaleString()}`,
    pageWidth - 15,
    10,
    { align: 'right' }
  );

  /* ================= TABLE ================= */

  const headers = [
    { header: 'No.', dataKey: 'no' },
    ...selectedFields.map(f => ({
      header: f.label,
      dataKey: f.key,
    })),
  ];

 const sourceData = this.getExportSourceData();

const body = sourceData.map((item: any, index) => {


      const row: any = { no: index + 1 };

      selectedFields.forEach(f => {

        // 🖼 IMAGE COLUMN
        if (f.key === 'st_image1') {

          row[f.key] = '';

          row.__img =
            this.stoneImageMap.get(item.st_id);

        } else {

          const rawValue = f.subKey
            ? item[f.key]?.[f.subKey]
            : item[f.key];

          row[f.key] =
            this.formatPdfValue(rawValue, f);
        }
      });

      return row;
    }
  );


  autoTable(doc, {

    columns: headers,
    body,

    startY: 24,
    margin: { left: 6, right: 6 },

    theme: 'grid',

    rowPageBreak: 'auto',

    tableWidth: pageWidth - 12,


    /* ---------- BASE STYLES ---------- */

    styles: {
      fontSize: 6,
      cellPadding: 1.3,
      overflow: 'linebreak',
      valign: 'middle',
    },

    headStyles: {
      fillColor: [193, 151, 37],
      textColor: 255,
      halign: 'center',
      fontSize: 7,
      fontStyle: 'bold',
    },

    columnStyles: {
      no: { cellWidth: 12, halign: 'center' },
      st_image: { cellWidth: 16 },
    },

    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },


    /* ---------- FIX IMAGE ROW HEIGHT ---------- */

    didParseCell: data => {

      if (
        data.section === 'body' &&
        data.column.dataKey === 'st_image1'
      ) {

        data.cell.styles.minCellHeight = 16;

        data.cell.styles.halign = 'center';
        data.cell.styles.valign = 'middle';
      }
    },


    /* ---------- DRAW IMAGE ---------- */

    didDrawCell: data => {

      if (data.column.dataKey !== 'st_image1') return;

      const rowAny = data.row.raw as any;

      const img = rowAny?.__img;

      if (!img) return;

      const padding = 3;

      const maxW =
        data.cell.width - padding * 2;

      const maxH =
        data.cell.height - padding * 2;

      const MAX_IMG_SIZE = 16;

      const size = Math.min(
        maxW,
        maxH,
        MAX_IMG_SIZE
      );

      const x =
        data.cell.x +
        (data.cell.width - size) / 2;

      const y =
        data.cell.y +
        (data.cell.height - size) / 2;

      doc.addImage(
        img,
        'JPEG',
        x,
        y,
        size,
        size,
        undefined,
        'FAST'
      );
    },


    /* ---------- FOOTER ---------- */

    didDrawPage: () => {

      doc.setFontSize(8);

      doc.text(
        `Page ${(doc as any).getNumberOfPages()}`,
        pageWidth / 2,
        pageHeight - 10,
        { align: 'center' }
      );
    },

  });

  doc.save('raw-stone-report.pdf');
}



 downloadExcel(): void {

  const selectedFields = this.selectedFields.filter(
    (field) => field.selected
  );

  if (!selectedFields.length) return;

  // numeric backend keys
  const numericKeys = [
    'st_unit_price',
    'st_total_wt',
    'st_subunit',
    'st_unit_quantity',
    'st_quantity',
    'st_sub_unit_price',
    'st_avg_unit_price',
    'st_avg_subunit',
    'st_avg_unit_quantity',
    'st_avg_sub_unit_price'
  ];

  /* =============================
     CREATE HEADER ROW
  ============================== */

  const headers = ['No.', ...selectedFields.map(f => f.label)];

  /* =============================
     CREATE DATA ROWS
  ============================== */

  const sourceData = this.getExportSourceData();

const rows = sourceData.map((item, index) => {


    const row: any = { 'No.': index + 1 };

    selectedFields.forEach((field) => {

      let value: any = '';

      // nested object
      if (field.subKey) {
        value = item[field.key]?.[field.subKey] ?? '';
      }

      // image field
      else if (field.isImage) {
        value = '';
      }

      // date field
      else if (field.isDate) {
        value = item[field.key]
          ? new Date(item[field.key]).toLocaleDateString()
          : '';
      }

      // normal field
      else {
        value = item[field.key];
      }

      // force numeric
      if (numericKeys.includes(field.key)) {
        value =
          value !== null &&
          value !== undefined &&
          value !== ''
            ? Number(value)
            : 0;
      }

      row[field.label] = value ?? '';
    });

    return row;
  });

  /* =============================
     HANDLE EMPTY CASE
  ============================== */

  let worksheet: XLSX.WorkSheet;

  if (rows.length === 0) {

    // 🔥 show headers only
    worksheet = XLSX.utils.aoa_to_sheet([headers]);

  } else {

    worksheet = XLSX.utils.json_to_sheet(rows);

    // force numeric cell types
    Object.keys(worksheet).forEach((cell) => {
      if (cell.startsWith('!')) return;

      const c = worksheet[cell];
      if (typeof c.v === 'number') {
        c.t = 'n';
      }
    });
  }

  /* =============================
     CREATE WORKBOOK
  ============================== */

  const workbook: XLSX.WorkBook = {
    Sheets: { 'Product List': worksheet },
    SheetNames: ['Product List'],
  };

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  FileSaver.saveAs(
    new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    'Raw-Stone-product-list.xlsx'
  );
}



  downloadJSONAll(): void {
   const data = this.getExportSourceData();
    const jsonString = JSON.stringify(data, null, 2); // Pretty print with indentation

    const blob = new Blob([jsonString], { type: 'application/json' });
    const fileName = 'Raw-Stone-product-list.json';

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(link.href); // Clean up
  }

  downloadCSV(): void {
   const data = this.getExportSourceData();

    if (!data.length) return;

    // Extract headers dynamically from the first object
    const selectedFields = this.selectedFields?.filter((f) => f.selected) || [];
    const headers = ['No.', ...selectedFields.map((f) => f.label)];
    const keys = selectedFields.map((f) => f.key);

    // Build CSV content
    let csvContent = headers.join(',') + '\n';

    data.forEach((item, index) => {
      const row = [
        index + 1,
        ...keys.map((key) => {
          const value = item[key];
          return typeof value === 'string' && value.includes(',')
            ? `"${value}"` // Wrap comma-containing values in quotes
            : value ?? '';
        }),
      ];
      csvContent += row.join(',') + '\n';
    });

    // Trigger file download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const fileName = 'Raw-Stone-product-list.csv';

    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    link.click();

    URL.revokeObjectURL(link.href); // Clean up
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  restoreColumnSelection() {
    localStorage.removeItem('stoneselected');
    this.selectedFields = [
      {
        key: 'st_item_category',
        label: 'Category',
        selected: true,
        subKey: 'name',
      },
      { key: 'st_metal_type', label: 'Metal Type', selected: true },
      { key: 'st_item_name', label: 'Name', selected: true },
      { key: 'st_item_size', label: 'Size', selected: true },
      { key: 'st_item_code', label: 'Code', selected: true },
      { key: 'st_quantity', label: 'Quantity', selected: true },
      { key: 'st_subunit', label: 'Per Stone in Each mala', selected: true },
      { key: 'st_unit_quantity', label: 'Total Mala', selected: true },
      { key: 'st_sub_unit_price', label: 'Per Stone price', selected: true },
      // { key: 'st_total_wt', label: 'Total Weight', selected: true },
      { key: 'st_unit_price', label: 'Per Gram Price', selected: true },
      { key: 'st_subunit', label: 'Per Stone Weight', selected: true },
    ];
  }

  async printTable() {

  // 🔒 preload stone images first
  await this.prepareStoneImages();

  let printContent = `
  <html>
  <head>
    <title>Raw Stone List</title>

    <style>

      body {
        font-family: Arial, sans-serif;
      }

      /* ===== TABLE GRID ===== */

      table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;
        font-size: 11px;
      }

      th, td {
        border-right: 2px solid #000;
        border-bottom: 2px solid #000;
        padding: 6px;
        text-align: center;
        vertical-align: middle;
        white-space: nowrap;
      }

      th:first-child,
      td:first-child {
        border-left: 2px solid #000;
      }

      thead th {
        border-top: 2px solid #000;
        background-color: #f2f2f2;
        font-weight: 600;
      }

      tbody tr:last-child td {
        border-bottom: 2px solid #000;
      }

      /* ===== IMAGE ===== */

      img {
        max-width: 80px;
        max-height: 80px;
        object-fit: contain;
        display: block;
        margin: auto;
      }

      /* ===== PRINT MODE ===== */

      @media print {

        @page {
          size: auto;
          margin: 8mm;
        }

        body {
          margin: 0;
        }

        svg,
        button {
          display: none !important;
        }

        thead {
          display: table-header-group;
        }

        tr {
          page-break-inside: avoid;
        }
      }

    </style>

  </head>
  <body>

    <h3>Raw Stone List</h3>

    <table>
      <thead>
        <tr>
          <th>No.</th>
  `;

  // 🧾 HEADERS
  this.selectedFields.forEach(field => {
    if (field.selected) {
      printContent += `<th>${field.label}</th>`;
    }
  });

  printContent += `
        </tr>
      </thead>
      <tbody>
  `;

  // 📦 ROWS
  const data = this.getExportSourceData();
  data.forEach((item, index) => {

    printContent += `
      <tr>
        <td>${(this.currentPage - 1) * this.itemsPerPage + index + 1}</td>
    `;

    this.selectedFields.forEach(field => {

      if (!field.selected) return;

      const value = item[field.key];

      let displayValue = '';

      // 🖼 IMAGE COLUMN
      if (field.key === 'st_image1') {

        const base64Img = this.stoneImageMap.get(item.st_id);

        printContent += `
          <td>
            ${base64Img ? `<img src="${base64Img}" />` : ''}
          </td>
        `;

        return;
      }

      // 📦 OBJECT HANDLING (CATEGORY ETC.)
      if (value && typeof value === 'object') {

        displayValue =
          value.name ||
          value.title ||
          value.category_name ||
          value.label ||
          '';

      } else {

  // 🗓 FORMAT DATE TO YYYY-MM-DD
  if (value && typeof value === 'string' && !isNaN(Date.parse(value))) {

    const dateObj = new Date(value);

    const year  = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day   = String(dateObj.getDate()).padStart(2, '0');

    displayValue = `${year}-${month}-${day}`;

  } else {
    displayValue = value ?? '';
  }

}


      printContent += `<td>${displayValue}</td>`;

    });

    printContent += `
      </tr>
    `;
  });

  printContent += `
      </tbody>
    </table>

  </body>
  </html>
  `;

  // 🖨 OPEN PRINT WINDOW
  const printWindow = window.open('', '_blank');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();

    // ⏳ wait before printing
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
      }, 200);
    };
  }
}

  onFieldToggle(field: any) {
    field.selected = !field.selected;
    this.saveSelectedFields();
    this.filterTable();
  }

  saveSelectedFields() {
    localStorage.setItem('selectedFields', JSON.stringify(this.selectedFields));
  }

  openStoneDetails(id: number): void {
    this.rawmetalservice.getRawMetalEntryById(id).subscribe(
      (response: any) => {
        const stone = response.data;

        const rows = this.selectedFields
          .filter((field) => field.selected)
          .map((field) => {
            let value = stone[field.key];

            if (field.subKey && typeof value === 'object' && value !== null) {
              value = value[field.subKey];
            }

            return `<p><strong>${field.label}:</strong> ${value ?? '-'}</p>`;
          })
          .join('');

        Swal.fire({
          title: `<strong style="font-size: 20px; color: #c19725;">Stone Details</strong>`,
          html: `
            <div style="text-align: left; font-size: 14px; max-height: 70vh; overflow-y: auto; font-family: 'Segoe UI', sans-serif;">
              <section style="margin-bottom: 1.5rem;">
                <h3 style="background: #fdf5e4; color: #c19725; padding: 6px 10px; border-left: 4px solid #c19725;">Item Info</h3>
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding-top: 8px;">
                  ${rows}
                </div>
              </section>
            </div>
          `,
          showCloseButton: true,
          focusConfirm: false,
          confirmButtonText: '<span style="color: white;">Close</span>',
          width: '650px',
          scrollbarPadding: false,
          customClass: {
            popup: 'stone-details-popup',
            confirmButton: 'stone-confirm-button',
          },
        });
      },
      (error) => {
        console.error('Error fetching stone details', error);
        Swal.fire(
          'Error',
          'Unable to fetch stone details. Please try again.',
          'error'
        );
      }
    );
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';

    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }
  private getExportSourceData(): any[] {

  const hasFilter =
    this.startDate ||
    this.endDate ||
    this.globalSearchText ||
    Object.values(this.searchValues).some(v => v) ||
    this.selectedViewMode !== 'all';

  return hasFilter
    ? this.filteredStockList
    : this.rawStonelist;
}

}
